import script from "./box-data-card.vue?vue&type=script&setup=true&lang=js"
export * from "./box-data-card.vue?vue&type=script&setup=true&lang=js"

import "./box-data-card.vue?vue&type=style&index=0&id=84c0f972&scoped=true&lang=less"
import "./box-data-card.vue?vue&type=style&index=1&id=84c0f972&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84c0f972"]])

export default __exports__